<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" > 
    Loading... </p></ngx-spinner>

<div class="content-wrapper" style="min-height: 307px">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="input-group mb-3" [formGroup]="SearchGroup">
                    <input type="text" class="form-control" formControlName="groupid" placeholder="รหัสกลุ่ม 6 หลัก">
                    <button class="btn btn-info btn-sm" (click)="Loadfarmerdata();">ค้นหา</button>
                </div>
            </div>
        </div>
       

    </div>

    <div class="col-lg-12">
      <mat-card class="example-card">
        <mat-form-field appearance="standard">
          <mat-label>ค้นหาข้อมูลในตาราง</mat-label>
          <input matInput (keyup)="applyFilter2($event)" placeholder="รายการที่ต้องการหา" #input>
          </mat-form-field>
          
          <table mat-table [dataSource]="fmdata" matSort style="width: 100%;">
          <!-- ลำดับตัดที่ Column -->
          <ng-container matColumnDef="cutrun" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header > ลำดับตัดที่ </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.cutrunning}} </td>
          </ng-container>

          <!-- หมายเลขแปลง Column -->
          <ng-container matColumnDef="landno" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header > หมายเลขแปลง </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.intlandno}} </td>
          </ng-container>
          
          <!-- โซน Column -->
          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header > โซน </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.supzone}} </td>
          </ng-container>
          
          <!-- โควตา Column -->
          <ng-container matColumnDef="fmcode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> โควตา </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.fmcode}}  </td>
          </ng-container>

           <!-- ชื่อ - สกุล Column -->
           <ng-container matColumnDef="fmfullname" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header > ชื่อ - สกุล </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.fmname}} </td>
          </ng-container>
          
          <!-- ประเภทอ้อย Column -->
          <ng-container matColumnDef="canetype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header > ประเภทอ้อย </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.CaneTypeName}}</td>
          </ng-container>
          
          <!-- อายุอ้อย Column -->
          <ng-container matColumnDef="caneage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> อายุอ้อย </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.caneage.toLocaleString('ar-TH')}}  </td>
          </ng-container>

           
          
          <!-- พื้นที่ Column -->
          <ng-container matColumnDef="plantvalue">
            <th mat-header-cell *matHeaderCellDef mat-sort-header > พื้นที่ </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.landvalue}}</td>
          </ng-container>
          
          <!-- กลุ่ม Column -->
          <ng-container matColumnDef="groupcode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> กลุ่ม </th>
            <td mat-cell *matCellDef="let element" id="Kanit"> {{element.groupCode}}  </td>
          </ng-container>

            <!-- หมายเลขแปลง Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
              <td mat-cell *matCellDef="let element" id="Kanit"> 
                <button class="btn btn-warning btn-sm" 
                data-bs-toggle="modal" (click)="Showdata(element.itid);" data-bs-target="#SetCutrun">บันทึกลำดับตัด</button>  
              </td>
            </ng-container>
          
        
          
          <tr mat-header-row  *matHeaderRowDef="GroupColum ; sticky: true;" ></tr>
          <tr mat-row *matRowDef="let row; columns: GroupColum;"></tr>
          
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
          </tr>
          </table>
          <mat-paginator  [pageSizeOptions]="[1, 5, 10, 25]" showFirstLastButtons aria-label="Select page of periodic elements"  
                           
          ></mat-paginator>
      </mat-card>
    </div>
    
    <!-- Modal -->
<div class="modal fade" id="SetCutrun" tabindex="-1" aria-labelledby="SetCutrun" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="SetCutrun">บันทึกลำดับตัดแปลงอ้อย</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="SaveCut">
            <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1" >ลำดับตัดที่</span>
                <input type="text" class="form-control" formControlName="weekrun" placeholder="เช่น 1.01,2.01"
                maxlength="4" minlength="4"
                [ngClass]="{ 'is-invalid': form.weekrun.errors }">
            </div>
            <p *ngIf="form.weekrun.errors?.required">กรุณากรอกข้อมูล</p>
            <p *ngIf="form.weekrun.errors?.pattern">กรุณากรอกข้อมูลแบบ 1.01 งวด 1. ลำดับ 01</p>
            <p *ngIf="form.weekrun.errors?.minlength">กรุณากรอกข้อมูลให้ครบ 4 ตัว</p>
            <p>งวด 1 1-15ธค. </p>
            <p>งวด 2 16-31ธค. </p>
            <p>งวด 3 1-15-มค </p>
            <p>งวด 4 16-31มค. </p>
            <p>งวด 5 1-15กพ. </p>
            <p>งวด 6 16-28กพ. </p>
            <p>งวด 7 1-15มีค. </p>
            <p>งวด 8 16-31มีค. </p>
            <p>งวด 9 1-15เมย. </p>
            <p>งวด 10 16-30เมย.</p>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="ChoseModal();" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" (click)="UpdateCutrunning();" data-bs-dismiss="modal">บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>